import { Component } from '@angular/core';

@Component({
  selector: 'app-sm-md-messenger',
  templateUrl: './sm-md-messenger.component.html',
  styleUrls: ['./sm-md-messenger.component.css']
})
export class SmMdMessengerComponent {

}
